import { useIsInternalAdmin } from "Components/Members/hooks/useIsInternalAdmin";
import Modal from "Components/Modal/Modal";
import ScheduleEntryForm from "Components/ScheduleEntry/ScheduleEntryForm";
import React, { FC, useState } from "react";
import ScheduleEntryDatailsView from "./ScheduleEntryDetailsView";
import { useScheduleEntryModal } from "./hooks/useScheduleEntryModal";

const ScheduleEntryModal: FC = () => {
	const isInternalAdmin = useIsInternalAdmin();
	const [isEdit, setIsEdit] = useState(isInternalAdmin);
	const isNewScheduleEntry = useScheduleEntryModal((state) => state.isNew);
	const isModalOpen = useScheduleEntryModal((state) => state.isOpen);
	const scheduleEntry = useScheduleEntryModal((state) => state.item);

	if (isModalOpen && scheduleEntry) {
		return (
			<Modal
				PaperProps={{
					// `form` has to be defined outside to support modal scrolling
					// https://github.com/mui-org/material-ui/issues/13253#issuecomment-512208440
					component: "form",
				}}
				modalController={useScheduleEntryModal.getState()}
			>
				{isEdit || isNewScheduleEntry ? (
					<ScheduleEntryForm
						close={useScheduleEntryModal.getState().close}
						isNew={isNewScheduleEntry}
						scheduleEntry={scheduleEntry}
						disableEdit={() => setIsEdit(false)}
					/>
				) : (
					<ScheduleEntryDatailsView
						scheduleEntry={scheduleEntry}
						close={useScheduleEntryModal.getState().close}
						edit={() => setIsEdit(true)}
					/>
				)}
			</Modal>
		);
	} else {
		return null;
	}
};

export default ScheduleEntryModal;
